/** Trigger a browser download of a text payload. */
export function downloadText(filename: string, contents: string, mimeType = "application/json") {
  const url = URL.createObjectURL(new Blob([contents], { type: mimeType }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/** Turn a character name into something safe to use as a filename stem. */
export function slugify(value: string, fallback = "record"): string {
  const slug = value
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return slug === "" ? fallback : slug;
}
